"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const platform_sdk_1 = require("@pureweb/platform-sdk");
exports.default = platform_sdk_1.LoggerProvider.getLogger('platform');
//# sourceMappingURL=Log.js.map